import ResourceLinkModel from '../../generated/types/model/resource/ResourceLinkModel';

export default class ResourceLinkViewModel extends ResourceLinkModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
